import React from "react";
  import "./Loader.css";

  const shimmer =
    "relative overflow-hidden bg-[#E5E9EB] before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent";

  const Bar = ({ className = "" }) => (
    <span className={`block rounded-md ${shimmer} ${className}`} />
  );

  const PolicyCardSkeleton = () => (
    <div
      className="policy_card_root relative rounded-[20px] overflow-hidden
                 w-[322px] min-w-[322px] max-w-full h-[202px] min-h-[202px]
                 ipad:min-w-[322px]
                 max767:w-full max767:min-w-[332px] max767:max-w-full
                 bg-[#F6F8F9] border border-[#E5E9EB]"
      aria-hidden="true"
    >
      <div className="flex flex-col justify-between w-full h-full p-4">
        <div className="flex items-start justify-between">
          <Bar className="h-4 w-16 rounded" />
          <Bar className="h-5 w-12 rounded-sm rtl:order-first" />
        </div>

        <div className="flex flex-col gap-2">
          <Bar className="h-3 w-28" />
          <Bar className="h-5 w-[55%] max767:w-[60%]" />
          <Bar className="h-3 w-32" />
          <Bar className="h-3.5 w-40 max767:w-[55%]" />
        </div>
      </div>
    </div>
  );

  const SkeletonLoader = () => {
    return (
      <>
        <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>
        <PolicyCardSkeleton />
        <PolicyCardSkeleton />
        <PolicyCardSkeleton />
      </>
    );
  };

  export default SkeletonLoader;
  